import React from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
} from "@mui/material";
import { MapPin } from "lucide-react";

const CountyTable = ({ data }) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="bg-white p-6 rounded-3xl shadow-sm border border-gray-100 mt-8">
            <div className="d-flex align-items-center gap-2 mb-6">
                <div className="p-2 bg-red-50 rounded-lg text-red-600">
                    <MapPin size={20} />
                </div>
                <h3 className="text-lg font-bold text-gray-800 m-0">
                    County-Level Construction Metrics (2025)
                </h3>
            </div>

            <TableContainer component={Paper} elevation={0} className="rounded-2xl border border-gray-100 overflow-hidden">
                <Table>
                    <TableHead>
                        <TableRow style={{ backgroundColor: "#f9fafb" }}>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                County
                            </TableCell>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                Permits
                            </TableCell>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                Permit Value ($B)
                            </TableCell>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                Jobs
                            </TableCell>
                            <TableCell style={{ color: "#4b5563", fontWeight: 700, fontSize: '0.75rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                                Jobs per 1,000
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {data.map((row, index) => (
                            <TableRow
                                key={index}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, '&:hover': { backgroundColor: '#fdf2f2' }, transition: 'background-color 0.2s' }}
                            >
                                <TableCell style={{ fontWeight: 600, color: '#111827' }}>{row.county}</TableCell>
                                <TableCell style={{ color: '#4b5563' }}>{row.permits.toLocaleString()}</TableCell>
                                <TableCell style={{ color: '#10b981', fontWeight: 600 }}>${row.permit_value_billion}B</TableCell>
                                <TableCell style={{ color: '#4b5563' }}>{row.jobs.toLocaleString()}</TableCell>
                                <TableCell style={{ color: '#4b5563' }}>
                                    <span className="bg-gray-100 px-2 py-1 rounded text-xs font-semibold">{row.jobs_per_1000}</span>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
};

export default CountyTable;